import { render, staticRenderFns } from "./ActiveFilter.vue?vue&type=template&id=2705ab54&"
import script from "./ActiveFilter.vue?vue&type=script&lang=ts&"
export * from "./ActiveFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports